import { FC } from "react";
import MarketPopup from "./MarketPopup";
import { Market } from "../../../domain/models/Market";

interface MarketSlideProps {
    index: number;
    market: Market;
}

const MarketSlide: FC<MarketSlideProps> = (props) => {
    return (
        <div className="relative flex flex-col mr-4 ti7:mr-3 tmax4:mr-1">
            <div className="relative flex gap-4 dmin2:min-w-[580px] dmin2:max-w-[580px] dmin2:h-[390px] di8:min-w-[520px] di8:max-w-[520px] di8:h-[360px] di7:min-w-[464px] di7:max-w-[464px] di7:h-[320px] ti3:h-[320px] td8:h-[280px] ti7:h-[250px] ti8:h-[420px] mi2:h-[405px] mi1:h-[390px] mi5:h-[320px]">
                <img
                    src={`images/markets/market-${props.index}.jpg`}
                    alt={`market-${props.index + 1}`}
                    className="w-full h-full object-cover rounded-[3px]"
                />
            </div>
            <div className="relative flex dmax5:flex-col justify-between mt-4">
                <div className="dmin5:max-w-[52%]">
                    <p className="H24 mb-1 truncate">{props.market.name}</p>
                    <p className="H16 mb-2.5 truncate">{props.market.date}</p>
                    <p className="H16 text-[#848484] truncate">{props.market.address}</p>
                </div>
                <MarketPopup index={props.index} market={props.market} />
            </div>
        </div>
    );
};

export default MarketSlide;
